import { render, staticRenderFns } from "./formatcurrency.vue?vue&type=template&id=60c200f6&"
import script from "./formatcurrency.vue?vue&type=script&lang=js&"
export * from "./formatcurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60c200f6')) {
      api.createRecord('60c200f6', component.options)
    } else {
      api.reload('60c200f6', component.options)
    }
    module.hot.accept("./formatcurrency.vue?vue&type=template&id=60c200f6&", function () {
      api.rerender('60c200f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yH2NPZG5IzXu/JS/formatcurrency.vue"
export default component.exports